<script setup lang="ts">
import IconButton from "~/components/IconButton.vue";
import { useSearchStore } from "~/store/searches";
import type { Search } from "~/common/types/types";
const store = useSearchStore();

const props = defineProps({
  search: {
      type: Object as PropType<Search>,
      required: true,
    },  
  });

async function executeSearch() {
  await store.executeSearch(props.search);
}
</script>

<template>
    <div>
        <IconButton @click="executeSearch" :disabled="search.status!=='pending'">Execute Search</IconButton>
    </div>
</template>